import React from "react";

const BillingSecurityNote = () => {
    return (
        //<p>This information is secured with 2048-bit encryption.</p> PART-12278
        <p> </p>
    );
};

export default BillingSecurityNote;
